import './PriceTable.css';
import React from 'react';
import {lang} from '../../common/baseData';

function PriceTable(props) {

  return (
      <div id="price-table" className="content content-page-holder">
        <div className="section-title">
          <h2>{props.title}</h2>
        </div>
        <span className="text-content">{props.subTitle}</span>
        <table className="table">
          <tbody>
          <tr>
            <td><b>{props.messages.WPT_T_ITEM_NAME_COLUMN_TITLE}</b></td>
            <td><b>{props.messages.WPT_T_PRICE_COLUMN_TITLE}</b></td>
          </tr>
          {
            props.hasOwnProperty('items') && Array.isArray(props.items) &&
            props.items.length ?
                props.items.map(item => (
                    <tr className="sort_tr" key={item.XML_ID}>
                      <td>ㅤ🔥ㅤ
                        <a href={item.URL}>
                          {item['NAME_' + lang.toUpperCase()]}
                        </a>
                      </td>
                      <td>{item.PRICE_FORMATED}</td>
                    </tr>
                )) :
                <></>
          }
          </tbody>
        </table>
      </div>
  );
}

export default PriceTable;